import { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import logo from "../../assets/images/logo-header.svg";
import gamePlayBg from "../../assets/images/banners/game-play-bg.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";
import { getGapLoadUrl } from "./cl_CrashSlice";
import axios from "axios";
import { socketConnect } from "../../services/socket/cl_index";
import { trackGameStartEvent } from "../../service/gtag";

const GameLaunch = () => {
  const { userDetails, balance } = useSelector((state) => state?.signIn);
  const [gameUrl, setGameUrl] = useState("");
  const [expandWin, setExpendWin] = useState(false);
  const localStorageToken = getFromLocalStorage("gk");
  const [token, setToken] = useState(localStorageToken);
  const [hasFetchedGapUrl, setHasFetchedGapUrl] = useState(false);
  const [isUserDetailsLoaded, setIsUserDetailsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (userDetails && userDetails.userId) {
      setIsUserDetailsLoaded(true);
    }
  }, [userDetails]);

  useEffect(() => {
    setToken(localStorageToken);
  }, [localStorageToken]);

  let location = useLocation();
  const dispatch = useDispatch();
  const [stateData, setStateData] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const stateParam = searchParams.get("state");
    if (stateParam) {
      // backward compat for old JSON format (pendingGame, bookmarks, etc.)
      setStateData(JSON.parse(decodeURIComponent(stateParam)));
    } else {
      // new format: individual query params
      const gameData = {
        game_code: searchParams.get("gamecode"),
        provider: searchParams.get("provider"),
        aggregator_type: searchParams.get("aggregator"),
        name: searchParams.get("name"),
        gamekind: searchParams.get("gamekind"),
        gamevariant: searchParams.get("gamevariant"),
        charged: searchParams.get("charged"),
        labelName: searchParams.get("labelname"),
        menuLink: searchParams.get("menulink"),
      };
      setStateData({
        gameData,
        gameClose: searchParams.get("gameclose") !== "false",
        returnPath: searchParams.get("returnpath"),
      });
    }
  }, [location.search]);

  const LoadGameData = stateData?.gameData;
  console.log("LoadGameData: ", LoadGameData);
  const gameclose = stateData?.gameClose;
  const [isGameOpen, setIsGameOpen] = useState(gameclose);
  var platformId = endpoints?.game_platform_id;
  var operatorId = endpoints?.game_operater_id;
  var gameBaseUrl = endpoints?.defender_end_point;
  var wacBasePath = endpoints?.wac_bace_path;
  var kironBasePath = endpoints?.kiron_basePath;
  var vleagueEndPoint = endpoints?.vleague;
  var WAC_PN = endpoints?.wac_pn;
  var vpsGame = endpoints?.penaltyShootout;
  var hub88_launch_url = endpoints?.hub88_basePath;
  const turboURL = process.env.REACT_APP_turbo;
  const stpUrl = process.env.REACT_APP_STP_LOAD_URL;
  const ezugiUrl = endpoints.ezugipath;
  const wacUrl = endpoints.wacEndpoint;
  const loginUser = endpoints.fasfasuser;
  const loginPass = endpoints.fasfasPass;
  const rootGameLaunch = endpoints.rootGameLaunch;
  const secretKey = endpoints.rootGameLaunchToken;
  const lobbyPath = endpoints.lobbyUrlPath;
  const depositPath = endpoints.depositUrlPath;
  const howzzatEndpoint = endpoints?.howzzatPath;
  const WAC_Load = `${wacBasePath}?token=${token}&pn=${WAC_PN}&lang=en&game=${LoadGameData?.game_code}&type=${LoadGameData?.charged}&home=http://${window.location.host}`;
  const kiron_Load = `${kironBasePath}&p=${token}&c=KES&l=en&s=default&eg=${LoadGameData?.game_code}`;
  const turbo_load = `https://${LoadGameData?.game_code}${turboURL}/?locale=en&cid=fasfas&token=${token}&demo=false`;
  const stp_load = `${stpUrl}${operatorId}/${LoadGameData?.gamekind}/${LoadGameData?.gamevariant}?token=${token}`;

  useEffect(() => {
    if (gameUrl) {
      const timer = setTimeout(() => {
        if (isLoading) {
          setIsLoading(false);
        }
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [gameUrl, isLoading]);

  useEffect(() => {
    if (iframeLoaded) {
      setIsLoading(false);
    }
  }, [iframeLoaded]);

  // useEffect(() => {
  //   if (isUserDetailsLoaded) {
  //     vleague_load = `${vleagueEndPoint}/games/vleague/index.html?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&brand=${operatorId}&token=${token}&userNumber=${userDetails?.userName}&userId=${userDetails?.userId}&playerId=${userDetails?.userId}&userCulture=en-US&currencyCode=KES&languageCode=en&redir=true&referralLogin=false&referralRegister=false`;
  //     penaltyShootout = `${vpsGame}?platformId=${platformId}&operatorId=${operatorId}&brand=${operatorId}&gameCode=${LoadGameData?.game_code}&token=${token}&playerId=${userDetails?.userId}&playerName=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&userRegion=KE&languageCode=en&gameName=penaltyshootout`;
  //     defenderURL = `${gameBaseUrl}?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&AppSession=${token}&userId=${userDetails?.userId}&userNumber=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&userRegion=KE`;
  //     howzzat_load = `${howzzatEndpoint}?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&AppSession=${token}&userId=${userDetails?.userId}&userNumber=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&languageCode=en`;
  //   }
  // }, [userDetails, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchNePlayUrl = async () => {
  //     try {
  //       const response = await axios.post(
  //         rootGameLaunch,
  //         {
  //           userId: userDetails.userId,
  //           playerToken: token,
  //           currency: "KES",
  //           gameId: LoadGameData?.game_code,
  //           token: secretKey,
  //           demoGame: false,
  //           provider: LoadGameData?.provider,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.data?.play_url) {
  //         setGameUrl(response.data.play_url);
  //       } else if (response.data?.errorCode) {
  //         console.error("NePlay Error:", response.data.errorMessage);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching NePlay URL:", error);
  //     }
  //   };

  //   if (
  //     isUserDetailsLoaded &&
  //     LoadGameData?.provider.toLowerCase() === "NeGames".toLowerCase()
  //   ) {
  //     fetchNePlayUrl();
  //   }
  // }, [LoadGameData, token, userDetails.userId, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchAndromedaUrl = async () => {
  //     if (
  //       !token ||
  //       !LoadGameData?.gameCode ||
  //       !operatorId ||
  //       !isUserDetailsLoaded
  //     )
  //       return;

  //     try {
  //       const response = await axios.post(
  //         wacUrl,
  //         {
  //           message: {
  //             method: {
  //               name: "getGameLaunchURL",
  //               credentials: {
  //                 login: loginUser,
  //                 password: loginPass,
  //               },
  //               params: {
  //                 token: {
  //                   value: token,
  //                 },
  //                 gameCode: {
  //                   value: LoadGameData?.gameCode,
  //                 },
  //                 device: {
  //                   value: LoadGameData?.device,
  //                 },
  //                 type: {
  //                   value: "CHARGED",
  //                 },
  //                 operatorId: {
  //                   value: operatorId,
  //                 },
  //               },
  //             },
  //           },
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       setGameUrl(response?.data?.url);
  //     } catch (error) {
  //       console.error("Error fetching game URL:", error);
  //     }
  //   };

  //   if (
  //     (LoadGameData?.provider === "leap" ||
  //       LoadGameData?.provider === "habanero") &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchAndromedaUrl();
  //   }
  // }, [token, LoadGameData, operatorId, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchGapLoadUrl = async () => {
  //     if (!hasFetchedGapUrl && isUserDetailsLoaded) {
  //       let request = {
  //         token: token,
  //         playerId: userDetails.userId + "",
  //         providerName: LoadGameData?.provider,
  //         deviceType: "MOBILE",
  //         lobby: false,
  //         balance: balance,
  //         clientIp: "127.0.0.1",
  //         redirectUrl: process.env.REACT_APP_FASFASREFERURL,
  //         extraData: {
  //           currency: "KES",
  //           platformId: "1",
  //           operatorId: "fasfas",
  //           brand: "fasfas",
  //           region: "KE",
  //           language: "en",
  //           gameId: LoadGameData.game_id,
  //           playerName: userDetails.userName,
  //         },
  //       };

  //       if (balance && userDetails.userId) {
  //         const result = await dispatch(getGapLoadUrl(request));
  //         if (result) {
  //           setGameUrl(result.url);
  //           setHasFetchedGapUrl(true);
  //         }
  //       }
  //     }
  //   };

  //   if (
  //     isUserDetailsLoaded &&
  //     (LoadGameData?.provider === "EVOLUTION" ||
  //       LoadGameData?.provider === "EZUGI" ||
  //       LoadGameData?.provider === "netent" ||
  //       LoadGameData?.provider === "RG" ||
  //       LoadGameData?.provider === "DC" ||
  //       LoadGameData?.provider === "JiLi")
  //   ) {
  //     fetchGapLoadUrl();
  //   } else if (LoadGameData?.provider === "turbogames") {
  //     setGameUrl(turbo_load);
  //   } else if (
  //     LoadGameData?.provider === "Split The Pot" ||
  //     LoadGameData?.provider === "stp"
  //   ) {
  //     setGameUrl(stp_load);
  //   } else if (LoadGameData?.provider === "kiron") {
  //     setGameUrl(kiron_Load);
  //   }
  // }, [LoadGameData, balance, token, isUserDetailsLoaded]);
  // useEffect(() => {
  //   const fetchEzugiUrl = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       const url = ezugiUrl;
  //       const time = Date.now();
  //       const game_code = LoadGameData?.game_code;
  //       const tableId = game_code?.includes("_")
  //         ? game_code?.split("_")[1]
  //         : game_code;
  //       const params = {
  //         playerId: userDetails.userId + "",
  //         operatorId: operatorId,
  //         token: token,
  //         currencyCode: "KES",
  //         openTable: Number(tableId),
  //         timestamp: time,
  //       };
  //       try {
  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         });
  //         setGameUrl(response?.data?.url);
  //       } catch (error) {
  //         console.error("Error fetching Ezugi URL:", error);
  //       }
  //     }
  //   };

  //   if (LoadGameData?.provider === "ezugi" && isUserDetailsLoaded) {
  //     fetchEzugiUrl();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  useEffect(() => {
    const fetchNePlayUrl = async () => {
      if (!gameUrl && isUserDetailsLoaded) {
        try {
          const url = hub88_launch_url;
          const time = Date.now();
          const game_code = LoadGameData?.game_code;
          if (
            !url ||
            !game_code ||
            !token ||
            !userDetails?.userId ||
            !operatorId
          ) {
            console.error("Missing required parameters for Hub88 launch");
            return;
          }

          const params = {
            playerId: userDetails.userId.toString(),
            platformId: 1,
            operatorId: operatorId,
            brandId: operatorId,
            playerToken: token,
            currencyCode: "KES",
            gameId: game_code,
            aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
            provider: LoadGameData?.provider,
            technology: "H5",
            gamePlatform: "WEB",
            playerIp: userDetails?.ip || "127.0.0.1",
            timestamp: time,
            countryCode: userDetails?.country || "KE",
            lobbyUrl: lobbyPath,
            depositUrl: depositPath,
          };

          const response = await axios.post(url, params, {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });

          if (response?.data?.launchUrl) {
            setGameUrl(response.data.launchUrl);
          } else {
            console.error("No launch URL in response:", response.data);
          }
        } catch (error) {
          console.error("Error fetching Hub88 URL:", error.response || error);
        }
      }
    };

    // if (
    //   LoadGameData?.aggregator_type?.toLowerCase() === "negames" &&
    //   isUserDetailsLoaded
    // ) {
    fetchNePlayUrl();
    // }
  }, [
    LoadGameData,
    token,
    userDetails.userId,
    operatorId,
    isUserDetailsLoaded,
  ]);
  // useEffect(() => {
  //   const fetchEzugiUrl = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "ezugi" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchEzugiUrl();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchHub88Url = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "hub88" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchHub88Url();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchBoomingGames = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }
  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: userDetails?.currency || "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           language: userDetails?.language || "en",
  //           returnUrl: window.location.origin,
  //           demo: false,
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "booming" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchBoomingGames();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchShacksevo = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: userDetails?.currency || "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           countryCode: userDetails?.country || "KE",
  //           language: userDetails?.language || "en",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "shacksevo" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchShacksevo();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  const navigate = useNavigate();
  const [showLottery, setShowLottery] = useState(false);
  const [lotteryFillPercentage, setLotteryFillPercentage] = useState(0);
  const lotteryUserId = userDetails?.userId;
  const lotteryUrl = lotteryUserId
    ? `${endpoints.lotteryLaunchUrl}${lotteryUserId}`
    : null;

  useEffect(() => {
    const handleLotteryMessage = (event) => {
      console.log("Received message:", event.data);
      if (event.data?.source !== "arcade") return;
      if (event.data?.type !== "LOTTERY_FILL_PERCENTAGE_EVENT") return;
      const pct = Number(event.data.payload?.lotteryFillPercentage);
      if (!Number.isFinite(pct)) return;
      setLotteryFillPercentage(Math.max(0, Math.min(100, pct)));
    };
    window.addEventListener("message", handleLotteryMessage);
    return () => window.removeEventListener("message", handleLotteryMessage);
  }, []);

  const expendHandiler = () => {
    setExpendWin(!expandWin);

    let elem = document.getElementById("fullscreen");

    if (!expandWin) {
      // Request fullscreen
      try {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
      } catch (error) {
        console.error("Error entering fullscreen:", error);
      }
    } else {
      // Exit fullscreen
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
      } catch (error) {
        console.error("Error exiting fullscreen:", error);
      }
    }
  };

  useEffect(() => {
    const pendingGame = localStorage.getItem("pendingGame");
    if (!LoadGameData && pendingGame) {
      try {
        const game = JSON.parse(pendingGame);
        const gameData = game.game ? game.game : game;
        setStateData({
          gameData,
          gameClose: false,
        });
      } catch (error) {
        console.error("Error parsing pending game:", error);
        navigate("/");
      }
    }
  }, []);

  useEffect(() => {
    if (LoadGameData) {
      const currentGames = localStorage.getItem("categoryGames");
      if (currentGames) {
        const parsedGames = JSON.parse(currentGames);
        localStorage.setItem(
          "categoryGames",
          JSON.stringify({
            ...parsedGames,
            currentGame: LoadGameData,
          })
        );
      }
    }
  }, [LoadGameData]);

  useEffect(() => {
    if (gameUrl && LoadGameData && userDetails?.userId && secretKey) {
      trackGameStartEvent(
        LoadGameData?.name || LoadGameData?.game_code || "Unknown Game",
        LoadGameData?.provider || "unknown",
        userDetails.userOtherInfo.phone,
        userDetails?.userType || "existing"
      );
    }
  }, [gameUrl, LoadGameData, userDetails, secretKey]);

  const goBack = () => {
    setGameUrl("");
    setIsGameOpen(false);
    setIframeLoaded(false);
    setIsLoading(true);
    localStorage.removeItem("pendingGame");

    const returnPath = stateData?.returnPath;
    const previousPath = localStorage.getItem("previousGamePath");
    const categoryGames = localStorage.getItem("categoryGames");

    if (returnPath) {
      navigate(returnPath);
    } else if (previousPath && categoryGames) {
      const { categoryName, gamesList } = JSON.parse(categoryGames);
      localStorage.removeItem("previousGamePath");
      navigate(previousPath, {
        state: {
          gamesList,
          title: categoryName,
          game_type: categoryName,
        },
      });
    } else {
      navigate("/");
    }
  };

  const handleIframeLoad = () => {
    setIframeLoaded(true);
    setIsLoading(false);
  };
  const [showStakeModal, setShowStakeModal] = useState(false);
  const [stakeInfo, setStakeInfo] = useState({
    stake: "",
    minStake: "",
    maxStake: "",
    gameName: "",
    message: "",
    betId: "",
    minStakeAmount: "",
    rejectionCode: "",
    maxStakeAmount: "",
  });

  useEffect(() => {
    socketConnect(dispatch);

    const handleBetRejection = (event) => {
      try {
        const data = event.detail;
        if (data.notificationType === "BET_REJECTED") {
          const betData = JSON.parse(data.data);
          if (
            betData.rejectionCode === "GAME_MIN_STAKE_VALUE_NOT_MET" ||
            betData.rejectionCode === "GAME_MAX_STAKE_LIMIT_EXCEEDED"
          ) {
            const minStakeAmount = Number(betData.gameMinStake) / 100;
            const maxStakeAmount = Number(betData.gameMaxStake) / 100;
            const userStake = Number(betData.stake);

            setStakeInfo({
              minStake: minStakeAmount,
              maxStake: maxStakeAmount,
              gameName: betData.gameName,
              betId: betData.betId,
              minStakeAmount: minStakeAmount,
              maxStakeAmount: maxStakeAmount,
              userStake: userStake,
              rejectionCode: betData.rejectionCode,
              message:
                betData.rejectionCode === "GAME_MIN_STAKE_VALUE_NOT_MET"
                  ? `Minimum stake for the game is `
                  : `Maximum stake for the game is `,
            });
            setShowStakeModal(true);
          }
        }
      } catch (error) {
        console.error("Error handling bet rejection:", error);
      }
    };

    window.addEventListener("notification", handleBetRejection);

    return () => {
      window.removeEventListener("notification", handleBetRejection);
    };
  }, [dispatch]);

  const handleCloseModal = () => {
    window.location.reload();
    setTimeout(() => {
      setShowStakeModal(false);
    }, 100);
  };

  return (
    <div className="SB-Lite SB-casinoGamePlayPage" id="fullscreen">
      {showStakeModal && (
        <div className="SB-modal SB-gameInfoModal open">
          <div className="SB-modal-dialog">
            <div className="SB-modal-content">
              <div className="SB-modal-close" onClick={handleCloseModal}>
                <div className="SB-iconSVG" title="close">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#icon-close`}></use>
                  </svg>
                </div>
              </div>
              <div className="SB-modal-body">
                <div className="SB-modal-header">
                  <div className="SB-modal-title">Bet Rejection</div>
                </div>
                <iframe src="https://lottie.host/embed/eedafe27-fd1f-4109-8e86-51bfbc396d99/peU7viMeD3.lottie" title="Bet Rejection Animation"></iframe>
                <div className="SB-gameplay-info">
                  <div className="SB-title SB-gameName">
                    <span>Game Name:</span> {stakeInfo.gameName}
                  </div>
                  <div className="SB-title SB-betID">
                    <span>ID:</span> {stakeInfo.betId}
                  </div>
                  <div className="SB-gameBet-rejected">
                    <p>
                      {stakeInfo.message}
                      <span className="SB-gameStake">
                        KSH{" "}
                        {stakeInfo.rejectionCode ===
                          "GAME_MIN_STAKE_VALUE_NOT_MET"
                          ? stakeInfo.minStakeAmount
                          : stakeInfo.maxStakeAmount}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="SB-casinoGamePlay">
        <div
          className="SB-casinoGamePlay-container"
          style={{ backgroundImage: `url(${gamePlayBg})` }}
        >
          <div className="SB-casinoGamePlay-box">
            <div className="SB-casinoGamePlay-boxHeader">
              <div className="SB-casinoGamePlay-boxHeader__left">
                <img src={logo} alt="Logo" />
                <div className="SB-casinoGamePlay-title">
                  {LoadGameData?.name}{" "}
                </div>
              </div>
              <div className="SB-casinoGamePlay-boxHeader__right">
                <div
                  className="SB-casinoGameLottery"
                  onClick={() => setShowLottery(true)}
                  style={{
                    position: "relative",
                    marginLeft: 12,
                    height: 26,
                    minWidth: 72,
                    padding: "0 12px",
                    border: "2px solid #1a1a4d",
                    borderRadius: 999,
                    background: "#3a3aff",
                    overflow: "hidden",
                    cursor: "pointer",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Open Lottery"
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      bottom: 0,
                      width: `${lotteryFillPercentage}%`,
                      background: "#7a7aff",
                      transition: "width 0.3s ease",
                      zIndex: 1,
                    }}
                  />
                  <div
                    style={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      lineHeight: 1,
                    }}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_6185_22194)">
                        <path
                          d="M7.91722 6.80449V5.19616C7.90369 5.07053 7.93962 4.94457 8.01742 4.84501C8.09522 4.74543 8.20875 4.68009 8.33389 4.66283V4.12533C8.20835 4.10708 8.09482 4.04087 8.01715 3.94063C7.93942 3.84039 7.90362 3.71393 7.91722 3.58783V2.78783C7.92015 2.74723 7.92575 2.70687 7.93389 2.66699H1.25057C0.919348 2.66798 0.601982 2.79999 0.367776 3.0342C0.13357 3.26841 0.00155574 3.58578 0.000566538 3.91699V4.32949C-0.00122084 4.45991 0.0276321 4.58894 0.0848036 4.70617C0.141975 4.82341 0.225868 4.92559 0.329733 5.00449C0.486046 5.11926 0.613146 5.26921 0.700755 5.44221C0.788355 5.61521 0.834008 5.80641 0.834008 6.00033C0.834008 6.19425 0.788355 6.38544 0.700755 6.55844C0.613146 6.73145 0.486046 6.88139 0.329733 6.99616C0.225868 7.07506 0.141975 7.17724 0.0848036 7.29448C0.0276321 7.41171 -0.00122084 7.54074 0.000566538 7.67116V8.08366C0.00155574 8.41487 0.13357 8.73225 0.367776 8.96645C0.601982 9.20066 0.919348 9.33267 1.25057 9.33366H7.93389C7.92575 9.29379 7.92015 9.25342 7.91722 9.21283V8.41283C7.90362 8.28673 7.93942 8.16026 8.01715 8.06002C8.09482 7.95978 8.20835 7.89357 8.33389 7.87533V7.33783C8.20875 7.32057 8.09522 7.25522 8.01742 7.15564C7.93962 7.05608 7.90369 6.93012 7.91722 6.80449ZM5.8339 7.25033H3.3339C3.22339 7.25033 3.11741 7.20643 3.03927 7.12828C2.96113 7.05015 2.91723 6.94417 2.91723 6.83366C2.91723 6.72315 2.96113 6.61717 3.03927 6.53903C3.11741 6.46089 3.22339 6.41699 3.3339 6.41699H5.8339C5.94441 6.41699 6.05039 6.46089 6.12853 6.53903C6.20667 6.61717 6.25057 6.72315 6.25057 6.83366C6.25057 6.94417 6.20667 7.05015 6.12853 7.12828C6.05039 7.20643 5.94441 7.25033 5.8339 7.25033ZM5.8339 5.58366H3.3339C3.22339 5.58366 3.11741 5.53976 3.03927 5.46162C2.96113 5.38348 2.91723 5.2775 2.91723 5.16699C2.91723 5.05649 2.96113 4.95051 3.03927 4.87237C3.11741 4.79423 3.22339 4.75033 3.3339 4.75033H5.8339C5.94441 4.75033 6.05039 4.79423 6.12853 4.87237C6.20667 4.95051 6.25057 5.05649 6.25057 5.16699C6.25057 5.2775 6.20667 5.38348 6.12853 5.46162C6.05039 5.53976 5.94441 5.58366 5.8339 5.58366Z"
                          fill="white"
                        />
                        <path
                          d="M8.75114 8.41283V9.21283C8.74821 9.25342 8.74267 9.29379 8.73447 9.33366H10.4178C10.749 9.33267 11.0664 9.20066 11.3006 8.96645C11.5348 8.73225 11.6668 8.41487 11.6678 8.08366V7.67116C11.6696 7.54074 11.6407 7.41171 11.5836 7.29448C11.5264 7.17724 11.4425 7.07506 11.3387 6.99616C11.1823 6.88139 11.0553 6.73145 10.9676 6.55844C10.88 6.38544 10.8344 6.19425 10.8344 6.00033C10.8344 5.80641 10.88 5.61521 10.9676 5.44221C11.0553 5.26921 11.1823 5.11926 11.3387 5.00449C11.4425 4.92559 11.5264 4.82341 11.5836 4.70617C11.6407 4.58894 11.6696 4.45991 11.6678 4.32949V3.91699C11.6668 3.58578 11.5348 3.26841 11.3006 3.0342C11.0664 2.79999 10.749 2.66798 10.4178 2.66699H8.73447C8.74267 2.70687 8.74821 2.74723 8.75114 2.78783V3.58783C8.76474 3.71393 8.72894 3.84039 8.65127 3.94063C8.57354 4.04087 8.46001 4.10708 8.33447 4.12533V4.66283C8.45967 4.68009 8.57321 4.74543 8.65094 4.84501C8.72874 4.94457 8.76467 5.07053 8.75114 5.19616V6.80449C8.76467 6.93012 8.72874 7.05608 8.65094 7.15564C8.57321 7.25522 8.45967 7.32057 8.33447 7.33783V7.87533C8.46001 7.89357 8.57354 7.95978 8.65127 8.06002C8.72894 8.16026 8.76474 8.28673 8.75114 8.41283Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6185_22194">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>{Math.round(lotteryFillPercentage)}%</span>
                  </div>
                </div>
                <div className="SB-casinoGameExpand">
                  <div className="SB-iconSVG" onClick={expendHandiler}>
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-expand"}`} />
                    </svg>
                  </div>
                </div>
                <div className="SB-casinoGameClose" onClick={goBack}>
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close"}`} />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="SB-casinoGamePlay-boxContent"
              style={{ position: "relative" }}
            >
              {isLoading && gameUrl && (
                <div className="SB-loader-container">
                  <div className="SB-loader"></div>
                </div>
              )}
              {gameUrl && (
                <iframe
                  id="virtualFrame"
                  src={gameUrl}
                  scrolling="yes"
                  height="100dvh"
                  width="100%"
                  frameBorder="0"
                  onLoad={handleIframeLoad}
                  title="Game Player"
                ></iframe>
              )}
              {lotteryUrl && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "#000",
                    zIndex: 5,
                    display: showLottery ? "block" : "none",
                  }}
                >
                  <div
                    onClick={() => setShowLottery(false)}
                    style={{
                      position: "absolute",
                      top: 5,
                      left: 12,
                      zIndex: 10,
                      cursor: "pointer",
                      padding: 6,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Back"
                  >
                    <div className="SB-iconSVG" style={{ width: 24, height: 24 }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff">
                        <use xlinkHref={`${icons}#${"icon-back"}`} />
                      </svg>
                    </div>
                      {/* <p style={{fontSize:"16px"}}>Loot Box</p> */}
                  </div>
                  <iframe
                    src={lotteryUrl}
                    title="Lottery"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    scrolling="yes"
                    allow="autoplay; fullscreen"
                    style={{ display: "block", border: 0 }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLaunch;
